<template>
  <div class="page-wrapper">
    <div>
      <template v-if="$route.query.request">
        <div class="notification notification-notice" style="padding:10px 15px 35px 15px;">
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{ $t('homeRequestSuccessfulMessage') }}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>
    <component v-bind:is="headerComponent"></component>
    <div class="section-boxes">
      <div class="container">
        <ul class="category-boxes">
          <li @click="trackPageClick('using_sitename')" class="category-boxes__item">
            <router-link class="category-boxes__item__link" :to="{ name: 'using-site' }">
              <div class="icon-box">
                <svg class="stroke-color" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M27 10V3C27 2.46957 26.7893 1.96086 26.4142 1.58579C26.0391 1.21071 25.5304 1 25 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V45C1 45.5304 1.21071 46.0391 1.58579 46.4142C1.96086 46.7893 2.46957 47 3 47H25C25.5304 47 26.0391 46.7893 26.4142 46.4142C26.7893 46.0391 27 45.5304 27 45V38" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1 7H27" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1 41H27" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11 4H17" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M47 31H35C34.4696 31 33.9609 30.7893 33.5858 30.4142C33.2107 30.0391 33 29.5304 33 29V27C33 26.4696 33.2107 25.9609 33.5858 25.5858C33.9609 25.2107 34.4696 25 35 25H47" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M47 12L38 9H36L31 13" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M36 25V15C36 14.4696 35.7893 13.9609 35.4142 13.5858C35.0391 13.2107 34.5304 13 34 13H14V35H34C34.5304 35 35.0391 34.7893 35.4142 34.4142C35.7893 34.0391 36 33.5304 36 33V31" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 10V38" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 37H6" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 33H6" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 37H10" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 30H33" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 26H33" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M35 28H37" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M33 19H31" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M29 19H17" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 class="title">{{ categories[getCategoryIdByName('using-site')].title }}</h3>
              <p class="text" v-html="categories[getCategoryIdByName('using-site')].body"></p>
            </router-link>
          </li>

          <li @click="trackPageClick('billing_support')" class="category-boxes__item">
            <router-link class="category-boxes__item__link" :to="{ name: 'billing-support' }">
              <div class="icon-box">
                <svg class="stroke-color" width="44" height="47" viewBox="0 0 44 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.2791 14.8C18.2276 14.8 23.5143 12.7606 25.3124 7.53198" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M32.4893 14.8H33.2577C33.6653 14.8 34.0562 14.9615 34.3444 15.2491C34.6326 15.5366 34.7945 15.9267 34.7945 16.3333V20.9333C34.7945 21.34 34.6326 21.73 34.3444 22.0176C34.0562 22.3051 33.6653 22.4667 33.2577 22.4667H31.7209" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.9739 14.8H10.2055C9.79793 14.8 9.40703 14.9615 9.11882 15.2491C8.83061 15.5366 8.6687 15.9267 8.6687 16.3333V20.9333C8.6687 21.34 8.83061 21.73 9.11882 22.0176C9.40703 22.3051 9.79793 22.4667 10.2055 22.4667H11.7423" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M33.2577 14.8V12.5C33.2577 9.45001 32.0433 6.52494 29.8818 4.36827C27.7202 2.2116 24.7885 1 21.7316 1C18.6747 1 15.743 2.2116 13.5814 4.36827C11.4199 6.52494 10.2055 9.45001 10.2055 12.5V14.8" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M30.184 15.5667C29.2226 15.2989 28.3409 14.8016 27.6153 14.1177C26.8897 13.4338 26.3419 12.5839 26.0193 11.6414" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22.5 27.0667H29.4157C30.4346 27.0667 31.4119 26.6628 32.1324 25.9439C32.8529 25.225 33.2577 24.25 33.2577 23.2333V22.4667" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.3528 28.3853C14.2926 25.4619 13.2163 21.9612 13.2792 18.388V14.8" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.5844 34.672C16.2157 35.7699 17.1051 36.698 18.1761 37.3765C19.247 38.055 20.4672 38.4635 21.7316 38.5667C22.9977 38.4769 24.2217 38.0756 25.2944 37.3987C26.3671 36.7217 27.255 35.7902 27.8788 34.6873" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M42.4632 45.4666C42.138 44.1368 41.5195 42.8962 40.6528 41.8352C39.7861 40.7741 38.693 39.9194 37.4532 39.3333L28.8624 35.27C28.3274 35.0159 27.8774 34.613 27.5666 34.1097C27.2558 33.6065 27.0974 33.0243 27.1104 32.4333V28.6" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.3527 28.3853V32.4333C16.354 33.0139 16.19 33.583 15.8799 34.0743C15.5698 34.5656 15.1262 34.959 14.6008 35.2086L5.99464 39.272C4.75771 39.8599 3.66762 40.7154 2.80365 41.7763C1.93967 42.8373 1.32353 44.077 1 45.4053" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M19.411 31.0227C20.1337 31.3767 20.9265 31.5653 21.7316 31.5747C24.0522 31.5747 26.2498 29.9033 27.8788 27.312" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M29.9689 15.5667C30.1163 16.4947 30.1882 17.4331 30.1841 18.3727C30.1888 20.3101 29.8827 22.2358 29.2773 24.0766" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 class="title">{{ categories[getCategoryIdByName('billing-support')].title }}</h3>
              <p class="text" v-html="categories[getCategoryIdByName('billing-support')].body"></p>
            </router-link>
          </li>

          <li @click="trackPageClick('account_support')" class="category-boxes__item">
            <router-link class="category-boxes__item__link" :to="{ name: 'account-support' }">
              <div class="icon-box">
                <svg class="stroke-color" width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M33.2001 15.5457C32.5534 15.5452 31.9234 15.3402 31.4001 14.9599C30.8769 14.5796 30.4872 14.0435 30.2867 13.4283C30.2558 13.3157 30.2514 13.1975 30.274 13.083C30.2966 12.9684 30.3456 12.8608 30.417 12.7684C30.4884 12.6761 30.5803 12.6017 30.6855 12.5511C30.7906 12.5006 30.9061 12.4752 31.0227 12.477H35.3774C35.4941 12.4752 35.6095 12.5006 35.7147 12.5511C35.8198 12.6017 35.9117 12.6761 35.9831 12.7684C36.0545 12.8608 36.1035 12.9684 36.1261 13.083C36.1487 13.1975 36.1443 13.3157 36.1134 13.4283C35.9129 14.0435 35.5232 14.5796 35 14.9599C34.4767 15.3402 33.8467 15.5452 33.2001 15.5457V15.5457Z" stroke="#333333" stroke-width="2" stroke-linecap="round"/>
                  <path d="M30.1333 20.9466H24C23.1867 20.9466 22.4067 20.6233 21.8316 20.0478C21.2564 19.4723 20.9333 18.6918 20.9333 17.8779V4.06871C20.9333 3.25484 21.2564 2.4743 21.8316 1.8988C22.4067 1.32331 23.1867 1 24 1H42.4C43.2133 1 43.9934 1.32331 44.5685 1.8988C45.1436 2.4743 45.4667 3.25484 45.4667 4.06871V17.8779C45.4667 18.6918 45.1436 19.4723 44.5685 20.0478C43.9934 20.6233 43.2133 20.9466 42.4 20.9466H34.7333L31.6667 25.5497" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M27.0667 11.7405V10.2061" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M39.3334 10.2061V11.7405" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.66663 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M7.1333 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M11.7333 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M10.2 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M14.8 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M13.2667 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M17.8667 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M16.3334 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M20.9333 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M19.4 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M24 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M22.4667 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M27.0667 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M25.5333 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M30.1333 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M28.6 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M33.2 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M31.6666 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M36.2667 39.3282V39.4817" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M34.7333 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M37.8 37.6404V37.7939" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M17.8666 7.10675H7.13331C6.72664 7.10675 6.33666 7.2684 6.0491 7.55615C5.76154 7.8439 5.59998 8.23417 5.59998 8.64111V31.6565" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M40.8667 31.6565V23.9847" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M5.59998 34.7252H40.8666L45.4666 42.3969" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1 42.3969L5.6 34.7252" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M28.6 42.3969H45.4667C45.4667 43.2108 45.1436 43.9913 44.5685 44.5668C43.9934 45.1423 43.2133 45.4656 42.4 45.4656H4.06667C3.25334 45.4656 2.47332 45.1423 1.8982 44.5668C1.32309 43.9913 1 43.2108 1 42.3969H17.8667" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
              <h3 class="title">{{ categories[getCategoryIdByName('account-support')].title }}</h3>
              <p class="text" v-html="categories[getCategoryIdByName('account-support')].body"></p>
            </router-link>
          </li>

          <li @click="trackPageClick('technical_support')" class="category-boxes__item">
            <router-link class="category-boxes__item__link" :to="{ name: 'technical-support' }">
              <div class="icon-box">
                <svg class="stroke-color" width="55" height="49" viewBox="0 0 55 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M8.20001 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M13.6 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M11.8 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M17.2 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M15.4 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M20.8 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M19 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M24.4 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M22.6 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M28 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M26.2 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M31.6 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M29.8 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M35.2 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M33.4 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M38.8 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M37 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M42.4 39.8654V40.0461" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M40.6 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M44.2 37.8768V38.0576" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M47.8 30.8269V3.7115C47.8 3.23207 47.6104 2.77228 47.2728 2.43327C46.9352 2.09426 46.4774 1.90381 46 1.90381H8.19999C7.7226 1.90381 7.26477 2.09426 6.9272 2.43327C6.58963 2.77228 6.39999 3.23207 6.39999 3.7115V30.8269" stroke="#333333" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
                  <path d="M6.39999 34.4423H47.8L53.2 43.4807" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1 43.4807L6.4 34.4423" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M33.4 43.4807H53.2C53.2 44.4396 52.8207 45.3592 52.1456 46.0372C51.4705 46.7152 50.5548 47.0961 49.6 47.0961H4.6C3.64522 47.0961 2.72954 46.7152 2.05441 46.0372C1.37928 45.3592 1 44.4396 1 43.4807H20.8" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.3 16.7812V19.565L18.838 20.1254C19.0561 21.0316 19.4145 21.8977 19.9 22.6923L18.496 24.8977L20.458 26.8681L22.654 25.4581C23.4352 25.9359 24.2852 26.2896 25.174 26.5065L25.732 29.0554H28.504L29.062 26.5065C29.9508 26.2896 30.8008 25.9359 31.582 25.4581L33.778 26.8681L35.74 24.8977L34.3 22.6923C34.7758 21.9078 35.1279 21.0541 35.344 20.1616L37.882 19.6012V16.8173L35.344 16.2569C35.1351 15.3393 34.7827 14.4607 34.3 13.6539L35.704 11.4485L33.742 9.47809L31.546 10.8881C30.7677 10.4086 29.9164 10.0605 29.026 9.85769L28.468 7.29077H25.696L25.138 9.85769C24.2476 10.0605 23.3962 10.4086 22.618 10.8881L20.422 9.47809L18.46 11.4485L19.9 13.6539C19.4225 14.4355 19.0759 15.2904 18.874 16.1846L16.3 16.7812Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M27.1 22.6923C29.5853 22.6923 31.6 20.6689 31.6 18.173C31.6 15.6771 29.5853 13.6538 27.1 13.6538C24.6147 13.6538 22.6 15.6771 22.6 18.173C22.6 20.6689 24.6147 22.6923 27.1 22.6923Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

              </div>
              <h3 class="title">{{ categories[getCategoryIdByName('technical-support')].title }}</h3>
              <p class="text" v-html="categories[getCategoryIdByName('technical-support')].body"></p>
            </router-link>
          </li>

          <li @click="trackPageClick('partners_authors')" class="category-boxes__item">
            <router-link class="category-boxes__item__link" :to="{ name: 'partners-authors' }">
              <div class="icon-box">
                <svg class="fill-color" width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_160_144)">
                    <path d="M31 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V37C0 37.2652 0.105357 37.5196 0.292893 37.7071C0.48043 37.8946 0.734784 38 1 38H15C15.2652 38 15.5196 37.8946 15.7071 37.7071C15.8946 37.5196 16 37.2652 16 37C16 36.7348 15.8946 36.4804 15.7071 36.2929C15.5196 36.1054 15.2652 36 15 36H2V2H30V36H27C26.7348 36 26.4804 36.1054 26.2929 36.2929C26.1054 36.4804 26 36.7348 26 37C26 37.2652 26.1054 37.5196 26.2929 37.7071C26.4804 37.8946 26.7348 38 27 38H31C31.2652 38 31.5196 37.8946 31.7071 37.7071C31.8946 37.5196 32 37.2652 32 37V1C32 0.734784 31.8946 0.48043 31.7071 0.292893C31.5196 0.105357 31.2652 0 31 0Z" />
                    <path d="M26 29C26 27.6739 25.4732 26.4021 24.5355 25.4645C23.5979 24.5268 22.3261 24 21 24C19.6739 24 18.4021 24.5268 17.4645 25.4645C16.5268 26.4021 16 27.6739 16 29C16 29.7762 16.1807 30.5418 16.5279 31.2361C16.875 31.9303 17.379 32.5343 18 33V39C18.001 39.1974 18.0604 39.3901 18.1707 39.5539C18.2811 39.7176 18.4374 39.845 18.62 39.92C18.8021 39.9966 19.0028 40.0175 19.1968 39.9801C19.3908 39.9428 19.5694 39.8488 19.71 39.71L21 38.41L22.29 39.71C22.3834 39.8027 22.4943 39.876 22.6161 39.9258C22.7379 39.9755 22.8684 40.0008 23 40C23.1312 40.0034 23.2613 39.976 23.38 39.92C23.5626 39.845 23.7189 39.7176 23.8293 39.5539C23.9396 39.3901 23.999 39.1974 24 39V33C24.621 32.5343 25.125 31.9303 25.4721 31.2361C25.8193 30.5418 26 29.7762 26 29ZM22 36.59L21.71 36.29C21.617 36.1963 21.5064 36.1219 21.3846 36.0711C21.2627 36.0203 21.132 35.9942 21 35.9942C20.868 35.9942 20.7373 36.0203 20.6154 36.0711C20.4936 36.1219 20.383 36.1963 20.29 36.29L20 36.59V33.9C20.66 34.0333 21.34 34.0333 22 33.9V36.59ZM21 32C20.4067 32 19.8266 31.8241 19.3333 31.4944C18.8399 31.1648 18.4554 30.6962 18.2284 30.148C18.0013 29.5999 17.9419 28.9967 18.0576 28.4147C18.1734 27.8328 18.4591 27.2982 18.8787 26.8787C19.2982 26.4591 19.8328 26.1734 20.4147 26.0576C20.9967 25.9419 21.5999 26.0013 22.1481 26.2284C22.6962 26.4554 23.1648 26.8399 23.4944 27.3333C23.8241 27.8266 24 28.4067 24 29C24 29.7956 23.6839 30.5587 23.1213 31.1213C22.5587 31.6839 21.7956 32 21 32Z" />
                    <path d="M21 8C21.2652 8 21.5196 7.89464 21.7071 7.70711C21.8946 7.51957 22 7.26522 22 7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6H11C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7C10 7.26522 10.1054 7.51957 10.2929 7.70711C10.4804 7.89464 10.7348 8 11 8H21Z" />
                    <path d="M6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14H25C25.2652 14 25.5196 13.8946 25.7071 13.7071C25.8946 13.5196 26 13.2652 26 13C26 12.7348 25.8946 12.4804 25.7071 12.2929C25.5196 12.1054 25.2652 12 25 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13Z" />
                    <path d="M26 17C26 16.7348 25.8946 16.4804 25.7071 16.2929C25.5196 16.1054 25.2652 16 25 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H25C25.2652 18 25.5196 17.8946 25.7071 17.7071C25.8946 17.5196 26 17.2652 26 17Z" />
                    <path d="M7 24C6.73478 24 6.48043 24.1054 6.29289 24.2929C6.10536 24.4804 6 24.7348 6 25C6 25.2652 6.10536 25.5196 6.29289 25.7071C6.48043 25.8946 6.73478 26 7 26H11C11.2652 26 11.5196 25.8946 11.7071 25.7071C11.8946 25.5196 12 25.2652 12 25C12 24.7348 11.8946 24.4804 11.7071 24.2929C11.5196 24.1054 11.2652 24 11 24H7Z" />
                  </g>
                  <defs>
                    <clipPath id="clip0_160_144">
                      <rect width="32" height="40" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>

              </div>
              <h3 class="title">{{ categories[getCategoryIdByName('partners-authors')].title }}</h3>
              <p class="text" v-html="categories[getCategoryIdByName('partners-authors')].body"></p>
            </router-link>
          </li>

        </ul>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, getCategoryPageName, getCategoryIdByName, trackPageView, trackPageClick } from '@/utils/common';

export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s`
    };
  },
  created() {
    if (this.$route.query.request) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    trackPageView('home');
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    articles() {
      return this.$store.state.articles;
    },
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    }
  },
  methods: {
    getCategoryPageName(catId) {
      return getCategoryPageName(catId, this.$store.getters.flowObject.pages);
    },
    getCategoryIdByName(catName) {
      return getCategoryIdByName(catName);
    },
    hideSuccessMessage() {
      this.$router.push({ path: window.location.pathname });
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/zeus-design.scss';

.section-boxes {
  padding: 80px 0;
}

.category-boxes {
  list-style-type: none;
  font-size: 14px;
  font-weight: 300;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  text-align: center;
  justify-content: center;
}
.category-boxes__item {
  margin: 20px 0;
  padding: 0 16px;
  width: 33.3333%;
}

.category-boxes__item__link {
  text-align: center;
  text-decoration: none;
  margin: 0 auto;
  line-height: 1.5rem;
  padding: 55px 30px 20px;
  display: block;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  border: 0;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease-in-out;
  .icon-box {
    height: 46px;
    margin: 0 0 30px;
  }
  .title {
    color: #287EFF;
    font-family:  Segoe UI, Arial, sans-serif;
    font-size: 24px;
    margin: 0 0 25px;
    font-weight: 400 !important;
  }

  svg {
    &.fill-color {
      path {
        fill: #333;
      }
    }
    &.stroke-color {
      path {
        stroke: #333;
      }
    }
  }

  .text {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: #333;
  }

  &:hover {
    background-color: #287EFF;
    color: #fff;

    .title,
    .text {
      color: #fff;
    }

    svg {
      &.fill-color {
        path {
          fill: #fff;
        }
      }
      &.stroke-color {
        path {
          stroke: #fff;
        }
      }
    }
  }
}

.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-notice {
  background: #dbf3ff;
}

.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}

.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}

.notification-dismiss {
  cursor: pointer;
  right: 0;
}

.notification-icon {
  left: 0;
}

.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}

.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}
@media (max-width: 991px) {
  .category-boxes__item {
    width: 50%;
  }
}
@media (max-width: 768px) {
  .section-boxes {
    padding: 30px 0;
  }
  .category-boxes__item {
    width: 100%;
    padding: 0;
  }
  .category-boxes__item__link {
    padding: 30px 15px;
  }
}
</style>
